const color = [
  "primary",
  "primary-lighten-1",
  "gray-lighten-1",
  "gray-lighten-2",
  "surface",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

const size = [
  "sm",
  "md",
  "lg"
] as const

export default {
  "base": "inline-flex items-center justify-center px-1 rounded-sm font-medium font-sans uppercase",
  "variants": {
    "color": {
      "primary": "",
      "primary-lighten-1": "",
      "gray-lighten-1": "",
      "gray-lighten-2": "",
      "surface": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "size": {
      "sm": "h-4 min-w-[16px] text-[10px]",
      "md": "h-5 min-w-[20px] text-[11px]",
      "lg": "h-6 min-w-[24px] text-[12px]"
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary"
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary-lighten-1"
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-gray-lighten-1"
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-gray-lighten-2"
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-surface"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary"
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary-lighten-1/50 text-primary-lighten-1"
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-gray-lighten-1/50 text-gray-lighten-1"
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-gray-lighten-2/50 text-gray-lighten-2"
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-surface/50 text-surface"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10"
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary-lighten-1 bg-primary-lighten-1/10"
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-gray-lighten-1 bg-gray-lighten-1/10"
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-gray-lighten-2 bg-gray-lighten-2/10"
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-surface bg-surface/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10"
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary-lighten-1 ring ring-inset ring-primary-lighten-1/25 bg-primary-lighten-1/10"
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-gray-lighten-1 ring ring-inset ring-gray-lighten-1/25 bg-gray-lighten-1/10"
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-gray-lighten-2 ring ring-inset ring-gray-lighten-2/25 bg-gray-lighten-2/10"
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-surface ring ring-inset ring-surface/25 bg-surface/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated"
    }
  ],
  "defaultVariants": {
    "variant": "outline" as typeof variant[number],
    "color": "neutral" as typeof color[number],
    "size": "md" as typeof size[number]
  }
}